
import { useContext } from "react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogAction } from "@/components/ui/alert-dialog";
import { ProjectContext } from "./ProjectStructureTab";
import ProjectSummaryHeader from "./ai-advisor/ProjectSummaryHeader";
import ProjectRequirementsForm from "./ai-advisor/ProjectRequirementsForm";
import AnalysisNavigation from "./ai-advisor/AnalysisNavigation";
import AnalysisContent from "./ai-advisor/AnalysisContent";
import { useProjectAnalysis } from "./ai-advisor/hooks/useProjectAnalysis";

const AIProjectAdvisorTab = () => {
  const { selectedProject } = useContext(ProjectContext);
  const {
    requirements,
    setRequirements,
    teamSize,
    setTeamSize,
    isAnalyzing,
    recommendation,
    resources,
    activeAnalysis,
    setActiveAnalysis,
    apiError,
    showNetworkAlert,
    setShowNetworkAlert,
    analyzeProject,
    getTeamStatsFromRecommendation
  } = useProjectAnalysis(selectedProject);

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <ProjectSummaryHeader selectedProject={selectedProject} resources={resources} />

      <ProjectRequirementsForm
        selectedProject={selectedProject}
        requirements={requirements}
        setRequirements={setRequirements}
        teamSize={teamSize}
        setTeamSize={setTeamSize}
        isAnalyzing={isAnalyzing}
        apiError={apiError}
        onAnalyzeProject={analyzeProject}
      />

      {recommendation && (
        <div className="flex-grow overflow-hidden flex flex-col">
          <AnalysisNavigation
            activeAnalysis={activeAnalysis}
            onAnalysisChange={setActiveAnalysis}
          />

          <AnalysisContent
            activeAnalysis={activeAnalysis}
            recommendation={recommendation}
            resources={resources}
            selectedProject={selectedProject}
            getTeamStatsFromRecommendation={getTeamStatsFromRecommendation}
          />
        </div>
      )}

      <AlertDialog open={showNetworkAlert} onOpenChange={setShowNetworkAlert}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Network Issue</AlertDialogTitle>
            <AlertDialogDescription>
              Network conditions are affecting the query. Please try again.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction onClick={() => setShowNetworkAlert(false)}>OK</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default AIProjectAdvisorTab;
